// disturbing.js
'use strict';

import { getItem, setItem } from './persist.js';

const PERSIST_KEY = '_dtState';

let _markedState = null;
let hasLoaded = false;

const getCachedMarkState = async () => {
  if (!hasLoaded) {
    _markedState = await getItem(PERSIST_KEY);
    hasLoaded = true;
  }

  return _markedState;
};

export const getMarkedAction = async () => {
  switch (await getCachedMarkState()) {
    case true:
      return 'shouldEnable';
    case false:
      return 'shouldDisable';
    default:
      return 'notMarked';
  }
};

/**
 * @param {object} param0
 * @param {boolean} param0.shouldDisturb Must be true or false
 */
export const mark = async ({ shouldDisturb }) => {
  if (typeof shouldDisturb !== 'boolean')
    throw new Error('`shouldDisturb` must be a boolean');

  if ((await getCachedMarkState()) === shouldDisturb) return;

  _markedState = shouldDisturb;
  hasLoaded = true;

  return setItem(PERSIST_KEY, shouldDisturb);
};
